'use strict';

function DemandSharesCSVService(gridExportCSVService) {
  var columnsHeaderMapToExport = {
    market: 'Market',
    calibrationName: 'Calibration Name',
    metric: 'Metric',
    createdOn: 'Created On',
    createdBy: 'Created By',
    lastModifiedOn: 'Last Modified On',
    lastModifiedBy: 'Last Modified By',
    calibrationStatus: 'Calibration Status',
    assigned: 'Assigned'
  };
  function exportToCSV(rows) {
    return gridExportCSVService.exportToCSV(rows, columnsHeaderMapToExport, 'DemandShares.csv');
  }
  return {
    exportToCSV: exportToCSV
  };
}
DemandSharesCSVService.$inject = ['GridExportCSVService'];
module.exports = DemandSharesCSVService;